import { api, currentCreche } from '../api'

const StaffSchedulesRepository = {
    index () {
        return api().$get(`/${currentCreche().uuid}/staff-schedules`)
    },

    create (payload) {
        return api().$post(`/${currentCreche().uuid}/staff-schedules`, payload)
    },

    update (uuid, payload) {
        return api().$put(`/${currentCreche().uuid}/staff-schedules/${uuid}`, payload)
    },

    delete (uuid) {
        return api().$delete(`/${currentCreche().uuid}/staff-schedules/${uuid}`)
    }
}

export default StaffSchedulesRepository
